import React, { useEffect } from 'react'
import { ClientsSheetVM } from '../../Structure/ViewModels/Admin/ClientsSheetVM'
import { useVM } from '../../Structure/utilities/ViewModelStructure'
import { Container } from 'react-bootstrap'
import Search from '../Utilities/Search'


const ClientsSheet = () => {
  const control = useVM<ClientsSheetVM>(new ClientsSheetVM())
  return (
    <Container>
    <div className='py-3'>
      <div className='d-flex py-2'>
        <div>
          <Search hasNoSelect onSearch={a=>{ control.Search = a; control.getData() }} />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
            <input
                className='input-field' 
                type="date" 
                value={control.From} 
                onChange={a=>{ control.From=a.target.value; control.getData() } } 
            />
        </div>
        <div className='px-1 h-100 d-flex my-auto'>
            <input
                className='input-field' 
                type="date" 
                value={control.To} 
                onChange={a=>{ control.To=a.target.value; control.getData() } } 
            />
        </div>
        {
            control.Data.length>0?(
                <div className='px-1 text-success d-flex'>
                    <div className='d-flex flex-column justify-content-center c-pointer'>
                        <div className=' text-center ' onClick={()=>control.downloadExcel()}>
                            {`->`} تحميل الملف
                        </div>
                    </div>
                </div>
            ):(null)
        }
      </div>
      {
        control.Show(
          <div  className='overflow-x-auto' style={{ maxHeight:'70vh' }}>
          <table   className=' w-100 text-center' style={{minWidth:'500px'}}>
            <thead style={{ position:'sticky' }}>
              <tr className='txt-color-I bg-light-gray'>
                    <th>الاسم العربي</th>
                    <th>الاسم الانجليزي</th>
                    <th>الموبايل</th>
                    <th>الرقم القومي</th>
                    <th>الجنسية</th>
                    <th>تاريخ الميلاد</th>
                    <th>العنوان</th>
                    <th>النوع</th>
                    <th>المسوق</th>
                    <th>الاشتراكات</th>
                    <th>المدفوعات</th>
              </tr>
            </thead>
            <tbody className='w-100'>
              {
              control.Data.map((item,index)=>(
                  <tr key={index} style={{background:index%2?'white':'rgba(200,200,200,0.2)'}}>
                      <td className='text-center'>{item.arabic_name}</td>
                      <td className='text-center'>{item.english_name}</td>
                      <td className='text-center'>+{item.dial_code} {item.mobile}</td>
                      <td className='text-center'>{item.national_id}</td>
                      <td className='text-center'>{item.nationality}</td>
                      <td className='text-center'>{item.birth_date}</td>
                      <td className='text-center'>{item.address}</td>
                      <td className='text-center'>{item.is_male?'ذكر':'انثى'}</td>
                      <td className='text-center'>{item.marketer_name}</td>
                      <td className='text-center'>{item.subscriptions}</td>
                      <td className='text-center'>{Math.floor(Number(item.total_paid)*100)/100}</td>
                  </tr>
              ))
              }
            </tbody>
          </table>
        </div>
        )
      }
    </div>
  </Container>
  )
}

export default ClientsSheet
